export const b2bLandingAmbassadorsSliderOptions = (instance, options) => {
    return {
        loop: false,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 0,
        simulateTouch: true,
        grabCursor: true,
    }
}